import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    try {
        const token = localStorage.getItem("token") || null;
        const user = localStorage.getItem("user")
            ? JSON.parse(localStorage.getItem("user"))
            : "";

        if (!(token && user)) {
            return <Navigate to="/" replace />;
        }
        return children;
    } catch (error) {
        return <Navigate to="/" replace />;
    }
};

export default ProtectedRoute;
